/* eslint-disable */
import { useCookies } from 'react-cookie';
import { useDataContext } from '../context';
import React, { useEffect, useState, useRef } from 'react';
import { jwtDecode } from 'jwt-decode';

function AllDepartment() {
  const { data, setData } = useDataContext();
  const [cookies] = useCookies(['session']);
  const [name, setName] = useState(null);
  
  // ป้องกันการยิงซ้ำใน StrictMode
  const hasFetchedGeneral = useRef(false);
  
  // ดึง API URL จาก Env
  const API_URL = import.meta.env.VITE_API_URL;

  // ---------------------------------------------
  // PART 1: Decode User & Find Employee Info
  // ---------------------------------------------
  useEffect(() => {
    let decodedToken = null;
    try {
      if (cookies?.session && typeof cookies.session === 'string') {
        decodedToken = jwtDecode(cookies.session);
      }
    } catch (error) {
      console.error('Error decoding token:', error.message);
    }

    if (decodedToken && data?.getAllEmployees) {
      const foundEmployee = data.getAllEmployees.find(
        (employee) => 
             (employee.username && decodedToken?.initials && employee.username === decodedToken.initials) ||
          (employee.employeeCode && decodedToken?.UserCode && employee.employeeCode === decodedToken.UserCode) ||
          (employee.email && decodedToken?.Email && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.Email.replace(/\s/g, '').toLowerCase()) ||
          (employee.email && decodedToken?.mail && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.mail.replace(/\s/g, '').toLowerCase()) ||
          (employee.email && decodedToken?.preferred_username && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.preferred_username.replace(/\s/g, '').toLowerCase()) ||
          (employee.email && decodedToken?.userPrincipalName && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.userPrincipalName.replace(/\s/g, '').toLowerCase())
      );
      setName(foundEmployee);
    }
  }, [cookies, data?.getAllEmployees]); // ใส่ dependency ให้ครบ

  // Helper ดึง Cookie
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  };
  
  const token = getCookie('empeoToken');

  // ---------------------------------------------
  // PART 2: Fetch Data ที่ต้องใช้ Token/Name (Empeo Shifts)
  // ---------------------------------------------
  useEffect(() => {
    // เช็คว่ามี empeoGetShifts หรือยัง ถ้ามีแล้วไม่ยิงซ้ำ
    if (token && name && !data.empeoGetShifts) {
      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');

      const raw = JSON.stringify({
        Authorization: token || null,
        employeeNo: name?.employeeCode,
        companyName: 'บริษัท บุญศิริโฟรเซ่นโปรดักส์ จำกัด',
      });

      fetch(`${API_URL}/empeoGetShifts`, {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.data) {
            setData((prevData) => ({ ...prevData, empeoGetShifts: result?.data?.data }));
          }
        })
        .catch((error) => console.error("Error fetching shifts:", error));
    }
  }, [token, name, data.empeoGetShifts]); // เพิ่ม dependency data.empeoGetShifts เพื่อเช็คกันซ้ำ

  // ---------------------------------------------
  // PART 3: Master Fetcher (General Data)
  // รวม fetchData1 - fetchData27 ไว้ที่นี่
  // ---------------------------------------------
  useEffect(() => {
    // ป้องกันการทำงานซ้ำใน StrictMode
    if (hasFetchedGeneral.current) return;
    hasFetchedGeneral.current = true;

    const controller = new AbortController();
    const signal = controller.signal;

    // รายการ API ทั้งหมดที่ต้องยิง (Config)
    // type: คือ key ใน response json ที่จะเอาข้อมูลออกมา ('resData' หรือ 'data' หรือ 'ous')
    const apiList = [
      { endpoint: '/getSupervisorQuestions', key: 'getSupervisorQuestions', type: 'resData' },
      { endpoint: '/getCrossQuestions', key: 'getCrossQuestions', type: 'resData' },
      { endpoint: '/getPeerQuestions', key: 'getPeerQuestions', type: 'resData' },
      { endpoint: '/getSelfQuestions', key: 'getSelfQuestions', type: 'resData' },
      { endpoint: '/getAllEvaluationAssignmentsYear', key: 'getAllEvaluationAssignmentsYear', type: 'resData' },
      { endpoint: '/getAnnualSelfEvaluationQuestion', key: 'getAnnualSelfEvaluationQuestion', type: 'resData' },
      { endpoint: '/getAnnualSupervisorEvaluationQuestion', key: 'getAnnualSupervisorEvaluationQuestion', type: 'resData' },
      { endpoint: '/getAllEvaluationYear', key: 'getAllEvaluationYear', type: 'resData' },
      { endpoint: '/getAllSupervisorTalentQuestions', key: 'getAllSupervisorTalentQuestions', type: 'resData' },
      { endpoint: '/getAllSelfTalentQuestions', key: 'getAllSelfTalentQuestions', type: 'resData' },
      { endpoint: '/getAllEvaluationAssignmentsTalent', key: 'getAllEvaluationAssignmentsTalent', type: 'resData' },
      { endpoint: '/getAllEvaluationTalent', key: 'getAllEvaluationTalent', type: 'resData' },
      { endpoint: '/getFavorites', key: 'getFavorites', type: 'data' },
      { endpoint: '/getAllQuestionItDev', key: 'getAllQuestionItDev', type: 'data' },
      { endpoint: '/getAllExpenseRequests', key: 'getAllExpenseRequests', type: 'data' },
      { endpoint: '/getAllCandidateTestHistory', key: 'getAllCandidateTestHistory', type: 'data' },
      { endpoint: '/getInterviewRecordAll', key: 'getInterviewRecordAll', type: 'data' },
      { endpoint: '/getAllTrainingRequests', key: 'getAllTrainingRequests', type: 'data' },
      { endpoint: '/getAllShiftChangeRequests', key: 'getAllShiftChangeRequests', type: 'data' },
      { endpoint: '/getAllCandidatePersonalityAssessmentHistory', key: 'getAllCandidatePersonalityAssessmentHistory', type: 'data' },
      { endpoint: '/getAllOU', key: 'getAllOU', type: 'ous' }, // สังเกต type เป็น ous
      { endpoint: '/getEvaluationRules', key: 'getEvaluationRules', type: 'data' },
      { endpoint: '/getAllEvaluation', key: 'getAllEvaluation', type: 'resData' },
    ];

    // ฟังก์ชันยิง API แบบ Generic
    const fetchGeneric = (item) => {
        // เช็คก่อนว่ามีข้อมูลใน Context หรือยัง (กันยิงซ้ำ)
        if (data[item.key]) return;

        fetch(`${API_URL}${item.endpoint}`, { method: 'GET', redirect: 'follow', signal })
            .then(res => res.json())
            .then(result => {
                // เลือก key จาก response ตาม type ที่กำหนด
                const value = result[item.type]; 
                if (value) {
                    setData(prev => ({ ...prev, [item.key]: value }));
                }
            })
            .catch(err => {
                if (err.name !== 'AbortError') console.error(`Error ${item.endpoint}:`, err);
            });
    };

    // 1. วนลูปยิง API ทั่วไป
    apiList.forEach(item => fetchGeneric(item));

    // 2. จัดการ Special Case: Documents & BotToken (ใช้ Basic Auth)
    const basicAuthHeaders = {
        Authorization: "Basic SHJAYm9vbnNpcmkuY28udGg6SHJAYnNyISEh",
    };

    // Documents
    if (!data.docOther) {
        fetch(`${API_URL}/documents`, { method: "GET", headers: basicAuthHeaders, signal })
            .then(res => res.json())
            .then(result => setData(prev => ({ ...prev, docOther: result.data })))
            .catch(err => console.error(err));
    }

    // Bot Token
    fetch(`${API_URL}/getBotToken`, { method: "GET", headers: basicAuthHeaders, signal })
        .then(res => res.json())
        .then(result => setData(prev => ({ ...prev, getBotToken: result.access_token })))
        .catch(err => console.error(err));

    // Assign Evaluations (อันนี้ Log อย่างเดียวตามโค้ดเก่า)
    fetch(`${API_URL}/assignEvaluations`, { method: "GET", redirect: "follow", signal })
        .then(res => res.text())
        .then(result => console.log("Assign Eval:", result))
        .catch(err => console.error(err));

    // 3. จัดการ Token (Create/Update Empeo Token)
    const currentToken = getCookie('empeoToken');
    if (!currentToken) {
        const myHeaders = new Headers();
        myHeaders.append('Authorization', `Bearer ${cookies?.session}`);
        
        fetch(`${API_URL}/empeoToken`, { method: 'POST', headers: myHeaders, redirect: 'follow', signal })
            .then(res => res.json())
            .then(result => {
                if (result.status === 'success') {
                    const token = result.data.access_token;
                    const expiresIn = result.data.expires_in; 
                    const expireDate = new Date(Date.now() + expiresIn * 1000);
                    document.cookie = `empeoToken=${token}; expires=${expireDate.toUTCString()}; path=/;`;
                    console.log('✅ Token updated');
                }
            })
            .catch(err => console.error('❌ Failed to fetch token:', err));
    } else {
        console.log('🔒 Token still valid');
    }

    // Cleanup: ยกเลิก request ถ้า component unmount
    return () => {
        controller.abort();
    };

  }, []); // Dependency [] คือทำแค่ครั้งแรก (Mount)

  return null;
}

export default AllDepartment;